<template>
  <div class="article" v-if="info">
    <div class="title">{{ info.title }}</div>
    <div class="des">
      <div>{{ info.cart_name }}</div>
      <div class="time">
        <Icon type="ios-clock-outline"></Icon><span>{{ info.add_time }}</span>
      </div>
      <div class="num">
        <Icon type="ios-eye-outline"></Icon><span>{{ info.visit }}</span>
      </div>
    </div>
    <div v-html="info.content" class="detail-content"></div>
  </div>
</template>

<script>
import { getArticleDetails } from "@api/public";
export default {
  name: "NewsDetail",
  data() {
    return {
      info: {},
      id: ""
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.getInfo();
  },
  methods: {
    getInfo() {
      getArticleDetails(this.id).then(res => {
        this.info = res.data;
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.article
  background #fff
  .title
    text-align center
    font-size 18px
    font-weight 700
    color #666
    height 80px
    line-height 80px
  .des
    width 300px
    margin 0 auto
    margin-bottom 20px
    text-align center
    display flex
    div
      color #999
      height 24px
      margin-top 5px
      &:first-child
        color red
        border 1px solid red
        padding 2px 5px
        border-radius 2px
        line-height 20px
        margin-top 0
    .time
      margin-left 20px
      span
        margin-left 5px
    .num
      margin-left 20px
      font-size 12px
      span
        margin-left 5px
  .detail-content
    border-top 1px solid #ccc
    margin-top 15px
    padding 15px 100px
</style>
